window.successStoriesScrollHandler = function () {
  let observer = new IntersectionObserver((entry, observer) => {
  let mobileButton = $("#mobile-contact-sales")
  let rightBox = $("#right-contact-sales")
  if (entry[0].intersectionRatio >= 0 || entry[0].isIntersecting) {
    mobileButton.toggleClass('d-none').toggleClass('d-block')
    rightBox.toggleClass('fade').toggleClass('show')
  }
})
  let bottomElement = document.querySelector("#bottom-contact-sales")
  observer.observe(bottomElement)
  document.addEventListener('touchstart', (event) => {
    $("#mobile-contact-sales").removeClass("d-none").addClass("d-block")
  }, { once: true})
}
